// global store so that simple toggles can be accessed without the need
// to wrap whole elements to vue components, which causes flickering due to bundling the vue

export var store = {
    state: {
        mobileStoreNavigationOpened: false,
    },
};
